<template>

      <q-page class="flex bg-image flex-center">
        <q-card v-bind:style="$q.screen.lt.sm?{'width': '80%'}:{'width':'35%'}">
          <q-card-section>
              <q-avatar size="103px" class="absolute-center shadow-5" > 
              
               <img src="../../assets/img/escudo-1.svg">
            </q-avatar>
          </q-card-section>
          <q-card-section>
            <div class="text-center q-pt-lg">
              <div class="col text-h4 ellipsis">Sistema de Control de Personal</div>
            </div>
            <div class="text-center q-pt-lg">
              <div class="col text-h6 ellipsis">Visor de incidencias</div>
            </div>
          </q-card-section>
          <q-card-section>
            <q-form class="q-gutter-md" @submit.prevent="auth">

              <q-input v-model="user.UserName" label="RFC (sin homoclave)" :rules="loginRules">
                <template v-slot:prepend><q-icon name="person" /></template>
              </q-input>

              <q-input v-model="user.Password" label="NIP" type="password" :rules="loginRules">
                <template v-slot:prepend><q-icon name="lock" /></template>
              </q-input>

              <div>
               <q-btn color="primary" class="full-width" label="Consultar" type="submit"  />
              </div>
            </q-form>
          </q-card-section>
        </q-card>
      </q-page>
</template>



<script>
import http from "@/services/http"


export default {
  
data: () => ({
  tab: 'login',
  date:null,
      user:{UserName:'', Password:''},
        loginRules: [v => !!v || 'Campo obligatorio',],
    }),
    methods:{
      async auth(){
        await http.loginVisor(this.user);
      }
    },
    }

</script>
